import React from 'react';
import { startOfMonth, endOfMonth, subMonths, subDays } from 'date-fns';
import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';

// Piezas compartidas por las pestañas de Control de personal.

export const TONOS = {
    verde: 'bg-emerald-500/10 text-emerald-700 ring-emerald-500/25 dark:text-emerald-300',
    violeta: 'bg-violet-500/10 text-violet-700 ring-violet-500/25 dark:text-violet-300',
    naranja: 'bg-orange-500/10 text-orange-700 ring-orange-500/25 dark:text-orange-300',
    ambar: 'bg-amber-500/10 text-amber-700 ring-amber-500/25 dark:text-amber-300',
    rojo: 'bg-red-500/10 text-red-700 ring-red-500/25 dark:text-red-300',
    azul: 'bg-sky-500/10 text-sky-700 ring-sky-500/25 dark:text-sky-300',
    cian: 'bg-teal-500/10 text-teal-700 ring-teal-500/25 dark:text-teal-300',
    gris: 'bg-muted text-foreground/80 ring-border',
    tenue: 'bg-transparent text-muted-foreground ring-border',
};

export const Pill = ({ tono = 'gris', children, className, title }) => (
    <span
        title={title}
        className={cn(
            'inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset',
            TONOS[tono],
            className,
        )}
    >
        {children}
    </span>
);

// Minutos → "1h 05min" / "12 min".
export const duracion = (min) => {
    const abs = Math.abs(Math.round(min || 0));
    if (abs >= 60) return `${Math.floor(abs / 60)}h ${String(abs % 60).padStart(2, '0')}min`;
    return `${abs} min`;
};

export const Kpi = ({ icon: Icon, label, value, sub, tone }) => (
    <Card>
        <CardContent className="p-4">
            <div className="flex items-start justify-between gap-2">
                <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">{label}</p>
                {Icon && <Icon className="h-4 w-4 text-muted-foreground" />}
            </div>
            <p className={cn('mt-2 text-2xl font-semibold tabular-nums', tone)}>{value}</p>
            {sub && <p className="mt-1 text-xs text-muted-foreground">{sub}</p>}
        </CardContent>
    </Card>
);

export const Avatar = ({ emp, size = 'h-9 w-9' }) =>
    emp.foto ? (
        <img src={emp.foto} alt="" className={cn(size, 'rounded-full border object-cover')} />
    ) : (
        <div className={cn(size, 'flex shrink-0 items-center justify-center rounded-full bg-primary/10 text-sm font-semibold text-primary')}>
            {(emp.nombre || '?').charAt(0)}
        </div>
    );

export const RANGOS = [
    { label: 'Este mes', calc: () => [startOfMonth(new Date()), new Date()] },
    { label: 'Mes anterior', calc: () => [startOfMonth(subMonths(new Date(), 1)), endOfMonth(subMonths(new Date(), 1))] },
    { label: 'Últimos 30 días', calc: () => [subDays(new Date(), 29), new Date()] },
];
